/* Colourful Cottons shared behaviour: hover-to-play video, drag sliders, modals, compact header. */
(function () {
  'use strict';
  var canHover = window.matchMedia('(hover:hover)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setSound(v, on) {
    v.muted = !on;
    var b = v.parentNode.querySelector('[data-cc-sound]'); if (!b) return;
    b.setAttribute('aria-pressed', on);
    b.setAttribute('aria-label', on ? b.dataset.labelOff : b.dataset.labelOn);
  }

  function initVideos(root) {
    (root || document).querySelectorAll('[data-cc-video]:not([data-cc-ready])').forEach(function (el) {
      el.setAttribute('data-cc-ready', '');
      var v = el.querySelector('video');
      if (!v) return;
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); el.classList.add('is-playing'); }
      function stop() { v.pause(); el.classList.remove('is-playing'); }
      if (canHover && !reduce) { el.addEventListener('mouseenter', play); el.addEventListener('mouseleave', stop); }
      var snd = el.querySelector('[data-cc-sound]');
      if (snd) snd.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var on = v.muted;
        if (on) document.querySelectorAll('[data-cc-video] video').forEach(function (o) { if (o !== v) setSound(o, false); });
        setSound(v, on);
        if (on && v.paused) play();
      });
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cc-shop]')) return;         // product link under a clip: just follow it
        if (v.paused) { e.preventDefault(); play(); }            // first tap plays (touch); second follows the link
        else if (el.tagName !== 'A') { stop(); }
      });
    });
  }

  function initTracks(root) {
    (root || document).querySelectorAll('[data-cc-track]:not([data-cc-ready])').forEach(function (track) {
      track.setAttribute('data-cc-ready', '');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + gap : 300; }
      var wrap = track.closest('[data-cc-slider]') || document;
      wrap.querySelectorAll('[data-cc-dir]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: step() * Number(b.dataset.ccDir), behavior: 'smooth' }); });
      });
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); } track.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); if (moved) { var i = Math.round(track.scrollLeft / step()); track.scrollTo({ left: i * step(), behavior: 'smooth' }); } });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });
    });
  }

  function initModals(root) {
    (root || document).querySelectorAll('[data-cc-open]:not([data-cc-ready])').forEach(function (b) {
      b.setAttribute('data-cc-ready', '');
      b.addEventListener('click', function () {
        var m = document.getElementById(b.dataset.ccOpen); if (!m) return;
        m.hidden = false; document.body.style.overflow = 'hidden';
        var c = m.querySelector('[data-cc-close]'); if (c) c.focus();
      });
    });
    (root || document).querySelectorAll('.cc-modal:not([data-cc-ready])').forEach(function (m) {
      m.setAttribute('data-cc-ready', '');
      function close() { m.hidden = true; document.body.style.overflow = ''; }
      m.querySelectorAll('[data-cc-close]').forEach(function (c) { c.addEventListener('click', close); });
      m.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* Compact header: on scroll the top row folds away, the logo glides to the left of the menu row
     and the icons to its right. Opt-in via theme setting (body.cc-compact-header). Desktop only. */
  function initCompactHeader() {
    if (!document.body.classList.contains('cc-compact-header')) return;
    var header = document.getElementById('header-component'); if (!header) return;
    var top = header.querySelector('.header__row--top'), bottom = header.querySelector('.header__row--bottom');
    if (!top || !bottom) return;
    var cols = bottom.querySelector('.header__columns'); if (!cols) return;
    var logo = top.querySelector('.header-logo'), actions = top.querySelector('header-actions');
    var search = top.querySelector('.header__column--right search-button');
    if (!logo) return;
    var left = document.createElement('div'); left.className = 'cc-compact-slot cc-compact-slot--logo header__column header__column--left';
    var right = document.createElement('div'); right.className = 'cc-compact-slot cc-compact-slot--actions header__column header__column--right';
    cols.insertBefore(left, cols.firstChild); cols.appendChild(right);
    var logoHome = logo.parentNode, logoNext = logo.nextSibling, actHome = actions && actions.parentNode, actNext = actions && actions.nextSibling;
    var searchHome = search && search.parentNode, searchNext = search && search.nextSibling;
    var on = false, tick = false, mq = window.matchMedia('(min-width: 990px)');
    function flip(el, before, after) {
      if (reduce) return;
      var dx = before.left - after.left, dy = before.top - after.top; if (!dx && !dy) return;
      el.classList.remove('cc-flip'); el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      requestAnimationFrame(function () { el.classList.add('cc-flip'); el.style.transform = ''; });
    }
    function setCompact(v) {
      if (v === on) return; on = v;
      var lb = logo.getBoundingClientRect(), ab = actions && actions.getBoundingClientRect(), sb = search && search.getBoundingClientRect();
      if (v) { left.appendChild(logo); if (search) right.appendChild(search); if (actions) right.appendChild(actions); header.classList.add('cc-is-compact'); }
      else { header.classList.remove('cc-is-compact'); logoHome.insertBefore(logo, logoNext); if (actions) actHome.insertBefore(actions, actNext); if (search) searchHome.insertBefore(search, searchNext && searchNext.parentNode === searchHome ? searchNext : null); }
      flip(logo, lb, logo.getBoundingClientRect()); if (search) flip(search, sb, search.getBoundingClientRect()); if (actions) flip(actions, ab, actions.getBoundingClientRect());
    }
    var scroller = document.querySelector('.page-wrapper');
    function scrollTop() { return (mq.matches && scroller ? scroller.scrollTop : 0) || window.scrollY || document.documentElement.scrollTop; }
    function check() {
      tick = false;
      if (!mq.matches) { setCompact(false); return; }
      var y = scrollTop();
      if (!on && y > 140) setCompact(true); else if (on && y < 40) setCompact(false);
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true }); if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    mq.addEventListener('change', check); check();
  }

  /* Sizes on product cards: on first hover, fetch the product's variants and show each size,
     crossing out sold-out ones. Works on Horizon's <product-card> and our .cc-card. Desktop only. */
  function initCardSizes() {
    var cfg = window.ccSettings || {};
    if (!cfg.cardSizes || !canHover) return;
    var want = String(cfg.sizeOption || 'Size').toLowerCase();
    var kinds = [{ card: 'product-card', img: '.card-gallery' }, { card: '.cc-card', img: '.cc-card__img' }];
    var cache = {};
    function sizesFor(url) {
      if (!cache[url]) {
        cache[url] = fetch(url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.options) return null;
            var opt = null;
            p.options.forEach(function (o) { if (String(o.name).toLowerCase() === want) opt = o; });
            if (!opt || opt.values.length < 2) return null;
            var key = 'option' + opt.position;
            return opt.values.map(function (val) {
              var ok = p.variants.some(function (v) { return v[key] === val && v.available; });
              return { label: val, available: ok };
            });
          })
          .catch(function () { return null; });
      }
      return cache[url];
    }
    document.addEventListener('pointerover', function (e) {
      for (var i = 0; i < kinds.length; i++) {
        var card = e.target.closest && e.target.closest(kinds[i].card);
        if (!card || card.dataset.ccSizes) continue;
        var img = card.querySelector(kinds[i].img); if (!img) return;
        var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
        if (!link) return;
        card.dataset.ccSizes = 'loading';
        var url = link.getAttribute('href').split(/[?#]/)[0];
        sizesFor(url).then(function (sizes) {
          card.dataset.ccSizes = 'done';
          if (!sizes) return;
          var box = document.createElement('div');
          box.className = 'cc-card-sizes'; box.setAttribute('aria-hidden', 'true');
          sizes.forEach(function (sz) {
            var span = document.createElement('span');
            span.textContent = sz.label;
            if (!sz.available) span.className = 'is-out';
            box.appendChild(span);
          });
          img.appendChild(box);
        });
        return;
      }
    }, { passive: true });
  }

  function init(root) { initVideos(root); initTracks(root); initModals(root); }
  /* Social icons in the header's top row, left of the logo. Markup comes from cc-vars. */
  function initHeaderSocial() {
    var tpl = document.getElementById('cc-header-social');
    var col = document.querySelector('#header-component .header__row--top .header__column--left');
    if (!tpl || !col || col.querySelector('.cc-header-social')) return;
    col.insertBefore(tpl.content.cloneNode(true), col.firstChild);
  }

  function boot() { init(); initHeaderSocial(); initCompactHeader(); initCardSizes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.CC = { init: init };
})();
